import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=c386ca7e&scoped=true&"
import script from "./memberCard.vue?vue&type=script&lang=js&"
export * from "./memberCard.vue?vue&type=script&lang=js&"
import style0 from "./memberCard.vue?vue&type=style&index=0&id=c386ca7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c386ca7e",
  null
  
)

export default component.exports